<template>
  <div id='teamEdit'>
    <div class="content-title">
      <Icon type="android-settings"></Icon>新增
      <div class="border"></div>
    </div>
    <teamForm ref="teamForm"></teamForm>
    <div class="text-center">
      <Button type="primary" @click="create" :disabled="disabled">新增</Button>
    </div>
  </div>
</template>

<script>
import { API } from "@/assets/config";
import teamForm from "./teamForm"


export default {
  name: "teamCreate",
  components: {
    teamForm
  },
  data() {
    return {
      id: this.$route.params.id,
      disabled: false,
      formItem: {}
    };
  },
  methods: {
    async create () {
      let validate = this.$refs.teamForm.validate()
      if(!validate) return;
      this.disabled = true
      this.formItem = this.$refs.teamForm.getFormItem()
      this.formItem.manager_company = this.formItem.name;
      this.axios.post(API.teams, this.formItem)
        .then(res => {
          this.$Message.info('新增成功')
          this.$router.push({name: 'teamList'})
        })
        .catch(err => {
          console.log(err)
          this.$Message.info('新增失敗')
          this.disabled = false
        })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/team/teamCreate.vue